<!--
 * @Author: wjc
 * @Date: 2023-11-15 09:54:21
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-02-02 10:17:12
 * @Description: 
-->
<template>
  <div>
    <NuxtLoadingIndicator :height="3" color="#0F67F8" :throttle="0" />
    <NuxtLayout>
      <el-config-provider :size="elConfig.size" :z-index="elConfig.zIndex" :locale="zhCn">
        <NuxtPage />
      </el-config-provider>
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
  import zhCn from 'element-plus/es/locale/lang/zh-cn'
  import { appName, appDescription } from '~/constants'

  const route = useRoute()
  const requestUrl = useRequestURL()
  const canonicalUrl = computed(() => new URL(route.fullPath, requestUrl.origin).href)

  useHead({
    titleTemplate: (titleChunk) => {
      return titleChunk ? `${titleChunk}` : appName
    },
    link: [
      {
        rel: 'canonical',
        href: canonicalUrl,
      },
    ],
  })

  useSeoMeta({
    title: '首页',
    description: appDescription,
    ogTitle: appName,
    ogDescription: appDescription,
    ogImage: '/logo.png',
    ogUrl: canonicalUrl,
    robots: 'index,follow',
  })

  const elConfig = ref<{
    size: 'default' | 'small' | 'large'
    zIndex: number
  }>({
    size: 'default',
    zIndex: 300,
  })
</script>

<style lang="scss">
  html {
    /**
    一般浏览器的默认字体大小为 16px，以10px 为基数计算rem，font-size: 1.4rem = 14px;
    注意：此设置在媒体查询中无效，媒体查询中，基数还是16px
  */
    font-size: 62.5%;
  }

  html,
  body,
  #__nuxt {
    padding: 0;
    margin: 0;
    height: 100%;
  }
</style>
